import { ComponentProps } from "react";
import {
  DefaultExtensionType,
  defaultStyles,
  FileIcon as FileIconComponent,
} from "react-file-icon";
type Props = {
  name: DefaultExtensionType | null;
} & Omit<ComponentProps<typeof FileIconComponent>, "extension">;

export default function FileIcon({ name, ...props }: Props) {
  if (!name) return null;
  return (
    <FileIconComponent extension={name} {...defaultStyles[name]} {...props} />
  );
}
